import { Position, Handle } from 'reactflow';
import React from 'react';
import { NodeData } from '../ProductFlowMap/productFlowMap.types';
import styles from '../ProductFlowMap/productFlowMap.module.scss';
import { HandleTypes } from 'enums/ProductFlowMapEnums';

const CustomNode: React.FC<{
  data: NodeData;
}> = ({ data }) => {
  return (
    <div className={styles.customNode}>
      <div className={styles.customNodeContent}>{data.label}</div>
      {data.hasTarget && (
        <Handle
          className={styles.leftHandle}
          type={HandleTypes.TARGET}
          position={Position.Left}
        />
      )}
      {data.hasSource && (
        <Handle
          className={styles.rightHandle}
          type={HandleTypes.SOURCE}
          position={Position.Right}
        />
      )}
    </div>
  );
};

export default CustomNode;
